import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from 'api';



// Unread notifications
export const checkForNotification = createAsyncThunk(
  'notifications/checkUnread',
  async () => {
    const response = await $axios.get('/notifications/unread'); 
    return response.data.data; 
  }
);

// Read notifications
export const checkForReadNotification = createAsyncThunk(
  'notifications/checkRead',
  async () => {
    const response = await $axios.get('/notifications/read'); 
    return response.data.data; 
  }
);

// Mark as read
export const markAsRead = createAsyncThunk(
  'notifications/markAsRead',
  async (notificationId, { rejectWithValue }) => {
    try {
      await $axios.put(`/notifications/${notificationId}/read`);
      return notificationId;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed' });
    }
  }
);

// Delete a notification
export const deleteNotification = createAsyncThunk(
  'notifications/delete',
  async (notificationId, { rejectWithValue }) => {
    try {
      await $axios.delete(`/notifications/${notificationId}`);
      return notificationId; 
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: 'Failed to delete' });
    }
  }
);


const initialState = {
  items: [],      
  readItems: [],   
  unreadCount: 0,
  status: 'idle',
};


const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    localMarkAsRead: (state, action) => {
      const id = action.payload;
      
      const item = state.items.find(n => n._id === id);
      if (item) {
        item.isRead = true;
        state.items = state.items.filter(n => n._id !== id);
        state.readItems.unshift(item); 
      }
      state.unreadCount = state.items.filter(n => !n.isRead).length;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch unread
      .addCase(checkForNotification.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(checkForNotification.fulfilled, (state, action) => {
        state.items = action.payload;
        state.unreadCount = action.payload.filter(n => !n.isRead).length;
        state.status = 'idle';
      })
      .addCase(checkForNotification.rejected, (state) => {
        state.status = 'idle';
      })

      // Fetch read notifications
      .addCase(checkForReadNotification.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(checkForReadNotification.fulfilled, (state, action) => {
        state.readItems = action.payload;
        state.status = 'idle';
      })
      .addCase(checkForReadNotification.rejected, (state) => {
        state.status = 'idle';
      })

      // Mark as read
      .addCase(markAsRead.fulfilled, (state, action) => {
        const id = action.payload;
        const item = state.items.find(n => n._id === id);
        if (item) {
          item.isRead = true;
          state.items = state.items.filter(n => n._id !== id);
          state.readItems.unshift(item);
        }
        state.unreadCount = state.items.filter(n => !n.isRead).length;
      })

      // Delete notification
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.items = state.items.filter(n => n._id !== action.payload);
        state.readItems = state.readItems.filter(n => n._id !== action.payload);
        state.unreadCount = state.items.filter(n => !n.isRead).length;
      });
  },
});

export const { localMarkAsRead } = notificationSlice.actions;
export default notificationSlice.reducer;
